import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { settingsSelectBackground, settingsSelectForeground, settingsNextStep } from '../../actions/settings';

class Background extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showHelp: false,
      showInspiration: false
    }
  }

  componentDidMount() {
    let _this = this;
    window.addEventListener('click', function(evt) {
      if(evt.target.closest('.help-modal') == null &&
        evt.target.closest('.inspiration-modal') == null &&
        evt.target.closest('.top-nav') == null) {
        _this.setState({
          showHelp: false,
          showInspiration: false
        })
      }
    })
  }

  onShowHelp() {
    this.setState({
      showHelp: true
    })
  }

  onCloseHelp(evt) {
    evt.preventDefault();
    this.setState({
      showHelp: false
    })
  }

  onShowInspiration() {
    this.setState({
      showInspiration: true
    })
  }

  onCloseInspiration(evt) {
    evt.preventDefault();
    this.setState({
      showInspiration: false
    })
  }

  selectBackground(backgroundId) {
    // Disregard if already selected
    if(this.props.settings.background == null || this.props.settings.background.id != backgroundId) {
      for(let i=0; i<this.props.backgrounds.length; i++) {
        if(this.props.backgrounds[i].id == backgroundId) {
          // found background
          if(this.props.backgrounds[i].colors.length > 0) {
            // has foreground and background
            this.addBackground(backgroundId, this.props.backgrounds[i].colors[0].src);
            this.props.settingsSelectForeground(this.props.backgrounds[i].src);
          } else {
            // has only background
            this.addBackground(backgroundId, this.props.backgrounds[i].src);
            this.props.settingsSelectForeground(null);
          }
        }
      }
    }
  }

  addBackground(backgroundId, backgroundSrc) {
    for(let i=0; i<this.props.backgrounds.length; i++) {
      if(this.props.backgrounds[i].id == backgroundId) {
        this.props.settingsSelectBackground(this.props.backgrounds[i], backgroundSrc, 'Default');
        this.props.settingsSelectForeground(this.props.backgrounds[i].src);
      }
    }
  }

  prevStep() {
    this.props.settingsNextStep(1);
  }

  nextStep() {
    this.props.settingsNextStep(3);
  }

  render() {
    // Preload images
    for(let i=0; i<this.props.backgrounds.length; i++) {
      new Image().src = this.props.backgrounds[i].src;
      if(this.props.backgrounds[i].colors.length > 0) {
        for(let j=0; j<this.props.backgrounds[i].colors.length; j++) {
          new Image().src = this.props.backgrounds[i].colors[j].src;
        }
      }
    }

    let backgroundsList = this.props.backgrounds.map((background) => {
      let backgroundColors = "";
      if(background.colors.length > 1) {
        let backgroundColorBlocks = background.colors.map((color) => {
          let isActive = "";
          if(this.props.settings.backgroundColor == color['title']) {
            isActive = " active"
          }
          return(
            <div className={"background__color-block" + isActive} onClick={this.addBackground.bind(this, background.id, color['src'])} >
              <div className="background__color-block-color" style={{backgroundColor: color['color']}}></div>
              <p className="background__color-block-title">{color['title']}</p>
            </div>
          )
        })
        backgroundColors = (
          <React.Fragment>
            <div className="background__color-blocks-wrapper d-flex">
              {backgroundColorBlocks}
            </div>
          </React.Fragment>
        )
      }
      /*<p className="background__title text-center">{background.title}</p>*/
      let backgroundSrc = "";
      if(background.colors.length > 0) {
        backgroundSrc = background.colors[0].src;
      }
      return(
        <div className="background col-12 pt-3" key={background.id}>
          <h3 className="background__title text-center">{background.title}</h3>
          <div className="background__images" onClick={this.selectBackground.bind(this, background.id)}>
            <img className="background__image" src={backgroundSrc} alt={background.alt} />
            <img className="foreground__image" src={background.src} alt={background.alt} />
          </div>
          {backgroundColors}
        </div>
      )
    })
    let nextButton = <button className="background-next text-center btn btn--large btn--primary" onClick={this.nextStep.bind(this)}>{this.props.wallConfig.next_btn_text}</button>;
    if(this.props.settings.background == null) {
      nextButton = <button className="background-next text-center btn btn--large btn--primary" onClick={this.nextStep.bind(this)} disabled>{this.props.wallConfig.next_btn_text}</button>;
    }

    let backgroundBlock = (
      <div className="background-container d-flex flex-column justify-content-between flex-grow-1">
        <div className="background-list__wrapper">
          {backgroundsList}
        </div>
        <div className="button-wrapper px-3 d-flex">
          <button className="background-next text-center btn btn--large btn--secondary" onClick={this.prevStep.bind(this)}>{this.props.wallConfig.back_btn_text}</button>
          {nextButton}
        </div>
      </div>
    )

    let backgroundStyle = "";
    let backgroundDiv = (
      <div className="background-initial-wrapper col-12 d-flex flex-column justify-content-center">
        <h2 className="background-placeholder text-center">
          PLEASE SELECT A BACKGROUND
        </h2>
      </div>
    );
    if(this.props.settings.background != null) {
      let backgroundSrc = {backgroundImage: 'url("' + this.props.settings.backgroundSrc + '")'};
      let foregroundSrc = {backgroundImage: 'url("' + this.props.settings.foregroundSrc + '")'};
      // <img className="foreground" src={this.props.settings.foregroundSrc} alt="foreground" />
      backgroundDiv = (
        <div className="background-wrapper col-12 p-0" style={backgroundSrc}>
          <div className="foreground" style={foregroundSrc}></div>
        </div>
      )
    } else {
      let backgroundSrc = {backgroundImage: 'url("' + this.props.wallConfig.main_background + '")'};
      backgroundDiv = (
        <div className="background-wrapper col-12 p-0" style={backgroundSrc}>
        </div>
      )
    }
    let assetList = backgroundBlock;

    let menu = (
      <div className="add-to-cart menu d-flex justify-content-between align-items-center">
        <div className="menu__items-wrapper">
        </div>
      </div>
    )

    let helpModal = null;
    if(this.state.showHelp) {
      let faqs = this.props.faqs.map((faq) => {
        return(
          <li className="help-modal__faq" key={"faq-" + faq.id}>
            <div className="help-modal__question">
              <a href={"#faq-" + faq.id} data-toggle="collapse" data-target={"#faq-" + faq.id}>
                <h5>{faq.question}</h5>
              </a>
            </div>
            <div className="help-modal__answer collapse" id={"faq-" + faq.id}>
              <p>{faq.answer}</p>
            </div>
          </li>
        )
      })
      helpModal = (
        <div className="help-modal">
          <a className="help-modal__close" href="#" onClick={this.onCloseHelp.bind(this)}>X</a>
          <div className="help-modal__title text-center">
            <h4>{this.props.wallConfig.help_title}</h4>
          </div>
          <div className="help-modal__body">
            <ul className="help-modal__faq-list">
              {faqs}
            </ul>
          </div>
        </div>
      )
    }

    let inspirationModal = null
    if(this.state.showInspiration) {
      let insp_text = this.props.wallConfig.insp_text.replaceAll('<a', '<a target="_blank"');
      inspirationModal = (
        <div className="inspiration-modal">
          <a className="inspiration-modal__close" href="#" onClick={this.onCloseInspiration.bind(this)}>X</a>
          <div className="inspiration-modal__title text-center">
            <h4>{this.props.wallConfig.insp_title}</h4>
            <div></div>
          </div>
          <div className="inspiration-modal__content"  dangerouslySetInnerHTML={{__html: insp_text}}></div>
        </div>
      )
    }

    return(
      <div className="container-fluid image-wall d-none d-lg-block d-xl-block">
        <div className="row">
          <div className="settings-column col-lg-2 d-flex flex-column px-0">
            <a className="settings-column__logo-link text-center" href="/">
              <img className="settings-column__logo" src={this.props.wallConfig.logo_url} alt="Visse Vasse" />
            </a>
            {assetList}
          </div>
          <div className="background-column col-lg-10 px-0">
            <div className="top-nav">
              <button className="btn btn--primary btn--large" onClick={this.onShowHelp.bind(this)}>{this.props.wallConfig.help_btn_text}</button>
              <button className="btn btn--primary btn--large mx-3" onClick={this.onShowInspiration.bind(this)}>{this.props.wallConfig.insp_btn_text}</button>
            </div>
            {backgroundDiv}
            {helpModal}
            {inspirationModal}
            {menu}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  settings: state.settings,
  backgrounds: state.backgrounds,
  wallConfig: state.wallConfig,
  faqs: state.faqs
})

const mapDispatchToProps = {
  settingsSelectBackground,
  settingsSelectForeground,
  settingsNextStep
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Background);
